import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { withStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Version from "version";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Slide from '@material-ui/core/Slide';
import Button from "components/CustomButtons/Button";
import ButtonX from '@material-ui/core/Button';
import ReactLoading from 'react-loading';
import Icon from "../components/Selfcare/Common/Icon";
import pink from '@material-ui/core/colors/pink';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import pricingPageStyle from "assets/jss/material-dashboard-pro-react/views/pricingPageStyle";

import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

// dotNetify
import dotnetify from 'dotnetify';

import auth from "../auth";
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

var reactPlugin = new ReactPlugin();

const MySwal = withReactContent(Swal);

const styles = theme => ({
    ...pricingPageStyle,
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    margin: {
        margin: theme.spacing(1),
    },
    cssLabel: {
        '&$cssFocused': {
            color: pink[500],
        },
    },
    cssFocused: {},
    cssUnderline: {
        '&:after': {
            borderBottomColor: pink[500],
        },
    },
});

const theme = createMuiTheme({
    palette: {
        primary: pink,
    },
    typography: { useNextVariants: true },
});


class OrderSimcard extends Component {
    constructor(props) {
        super(props);
        this.vm = dotnetify.react.connect("OrderSimcard", this, {
            headers: {
                Authorization: "Bearer " + auth.getAccessToken(),
                ClientVersion: Version.getVersion(),
                ServerToken: window.sessionStorage.ServerToken
            },
            exceptionHandler: _ => auth.signOut()
        });
        // Set up function to dispatch state to the back-end.
        this.dispatchState = state => this.vm.$dispatch(state);

        // we use this to make the card to appear after the page has been rendered
        this.state = {
            show: false,
            redirect: null,
            toUrl: null,
            OrderSent: false,
            OrderError: '',
            buzy: true,
            ErrorField: '',
            ErrorText: '',
        };
    }
    componentDidMount() {
        setTimeout(
            function () {
                this.setState({ show: true });
            }.bind(this),
            700
        );
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (nextState.OrderSent && !this.state.OrderSent) {
            MySwal.fire({
                title: this.props.t('selfcare:notification.ordersent'),
                html: this.props.t('selfcare:notification.inmailboxwithindays'),
                icon: 'success',
                confirmButtonColor: '#e91e63',
            }).then((result) => {
                this.setState({ redirect: true, toUrl: '/overview' });
            });
        }
        if (nextState.OrderError && !this.state.OrderError) {
            MySwal.fire({
                title: this.props.t('selfcare:notification.orderfailed'),
                html: nextState.OrderError,
                icon: 'error',
                confirmButtonColor: '#e91e63',
            });
            this.setState({ buzy: false });
        }
        if (nextState.Address && !this.state.Address) {
            this.setState({ buzy: false });
        }
    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
        this.vm.$destroy();
    }

    hideAlert = () => {
        this.setState({
            alert: null, buzy: false, OrderError: '', OrderSent: false
        });
    }

    navigateTo = url => {
        this.setState({ show: false });
        setTimeout(
            function () {
                this.setState({
                    toUrl: url,
                    redirect: true
                });
            }.bind(this),
            300
        );
    }
    render() {
        console.debug('OrderSimcard render');
        const classes = this.props;
        const { t } = this.props;
        return (
            <div style={{ height: '100vh' }}>
                {this.state.redirect ? <Redirect to={this.state.toUrl} /> : null}
                    <div style={{ backgroundColor: '#e91e63', color: '#FFF', padding: '20px' }}>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={10} md={8} lg={6} xl={4} >
                                <Icon name="simcard" size={48} color="#FFFFFF" />
                                <div style={{ fontSize: '20px', fontWeight: '700', maxWidth: '900px' }}>
                                    {t('selfcare:item.didlosesim')}
                                </div>
                                <div style={{ fontSize: '14px' }}>
                                    <span dangerouslySetInnerHTML={{ __html: t('selfcare:info.simorder', { 0: this.state.SimPrice }) }} />
                                </div>
                            </GridItem>
                        </GridContainer>
                    </div>
                    <div>
                        <GridContainer justify="center">
                            <MuiThemeProvider theme={theme}>
                                <GridItem xs={12} sm={10} md={8} lg={6} xl={4} >
                                    {!this.state.OrderOpen && <div>
                                        <div style={{ paddingTop: '20px', paddingLeft: '10px', fontWeight: '700' }}>{t('selfcare:item.simsentto')}:</div>
                                        <div style={{ paddingLeft: '10px' }} dangerouslySetInnerHTML={{ __html: this.state.Address }} />
                                        <GridContainer direction="row">
                                            <GridItem>
                                                <div style={{ paddingTop: '20px' }}>
                                                    <Button size="sm" onClick={() => { this.setState({ buzy: true }); this.dispatchState({ PerformChange: true }); }} disabled={this.state.buzy} variant="contained" style={{ borderRadius: '19px', marginRight: '10px' }} color="rose">{t('selfcare:button.order')}</Button>
                                                    <ButtonX id='cancel' size="small" disabled={this.state.buzy} onClick={() => { this.navigateTo('/overview'); }}>{t('selfcare:button.cancel')}</ButtonX>
                                                </div>
                                            </GridItem>
                                        </GridContainer></div>}
                                    {this.state.OrderOpen && <div style={{ paddingTop: '20px', paddingLeft: '10px' }}>
                                        {this.state.OrderStatus}{this.state.CanActivate && <Button size="sm" onClick={() => { this.setState({ buzy: true }); this.navigateTo('/activate-simcard'); }} disabled={this.state.buzy} variant="contained" style={{ borderRadius: '19px', marginLeft: '10px' }} color="rose">{t('selfcare:button.toactivation')}</Button>}<br />
                                        <div style={{ paddingTop: '10px' }}><Button id='back' color="rose" disabled={this.state.buzy} onClick={() => { this.navigateTo('/overview'); }}><Icon name="back" size={32} color="#FFFFFF" />{t('selfcare:button.back')}</Button></div>
                                    </div>}
                                        {this.state.buzy && <GridItem>
                                            <ReactLoading type={"bubbles"} color={"#e91e63"} height={'50px'} width={'50px'} />
                                        </GridItem>}
                                    </GridItem>
                            </MuiThemeProvider>
                        </GridContainer>
                    </div>
            </div>
        );
    }
}
OrderSimcard.propTypes = {
};

export default compose(
    withStyles(styles),
    withTranslation(),
)(withAITracking(reactPlugin, OrderSimcard));
